module.exports = __webpack_public_path__ + "img/1.70f611d1.jpg";